import React, {useState} from 'react';
import {LoginForm} from "./LoginForm";
import {RecoveryPswForm} from "./RecoveryPswForm";


export function Login() {

    const [recoveryPsw, setRecoveryPsw] = useState(false);

    return (
        <div className={'container'}>
            <div className={'row justify-content-center'}>
                <div className="col-sm-12 col-md-8 col-lg-8 mt-5">
                    <div className={'d-flex gap-4 align-items-center h-100 justify-content-center'}>
                        <div className={'d-flex flex-column justify-content-center gap-3 pe-5'}>
                            <img src="./assets/welcome-logo.png" alt=""/>
                            <h4 className={'text-center'}>COLL<span className={'text-yellow-500'}>QB</span>
                            </h4>
                        </div>
                        <div className={'py-5'}>
                            <div className={'login-container p-5 py-5 px-md-4 px-lg-5 border-start border-cyan-100'}>
                                <div className={"title"}>
                                    <h3>
                                        {!recoveryPsw ? 'Login' : 'Reset password'}
                                    </h3>
                                </div>
                                {!recoveryPsw ? <LoginForm recoveryPswHandler={() => setRecoveryPsw(true)}/> :
                                    <RecoveryPswForm backHandler={() => setRecoveryPsw(false)}/>}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
